let inject = ['$scope', '$uibModalInstance', '$timeout', 'SessionService', 'modalOptions', 'CartService'];

class CreateTemplateModalController {
  constructor ($scope,$uibModalInstance, $timeout, SessionService, modalOptions, CartService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.CartService = CartService;
    this.SessionService = SessionService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = modalOptions;
    this.globals = modalOptions.globals;
    this.cartTemplate = {};
  }

  createCartTemplate() {
    this.cartTemplate.loading = true;
    let cartId = this.SessionService.get('cartId') || '';
    let userId = '';
    try {
      userId = this.globals.currentUser.userId;
    }
    catch (e) {
    }
    let sellerId = '';
    try {
      sellerId = this.globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.CartService.createCartTemplate({'cartId': cartId, 'userId': userId, 'sellerId': sellerId, 'cartTemplateName': this.cartTemplate.name}).then(response => {
      this.cartTemplate.loading = false;
      this.cartTemplate.response = response;
    }).catch(reason => {
      this.cartTemplate.loading = false;
      this.cartTemplate.response = reason;
    });
  };

  clearCreateTemplateForm() {
    this.cartTemplate = {};
    this.ok();
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

CreateTemplateModalController.$inject = inject;

export default CreateTemplateModalController;



// WEBPACK FOOTER //
// ./www/components/cart/create-template-modal/create-template-modal.controller.js